import { cardRef, defineGameCard, onResolve, unitTarget } from '../authoring/index.js';
import { plannedUnitId } from './slime-helpers.js';
export const LiquefactionCard = defineGameCard({
    id: 'liquefaction',
    gameplay: {
        type: 'SPELL', cost: 5,
        planning: {
            target: unitTarget({ side: 'enemy', cardinality: { min: 1, max: 1 } }),
        },
    },
    presentation: {
        name: 'Разжижение',
        description: 'Превратите выбранную карту соперника в Безвольного слизня 1/1 без способностей. Превращение не считается гибелью.',
        glyph: {
            colors: ['#10213A', '#6C89A4', '#7A97B2', '#567292', '#3D5978'],
            rows: [
                '....................',
                '....................',
                '.......11111........',
                '......12223311......',
                '....11223333331.....',
                '...1222333322221....',
                '...1233332222241....',
                '..133333222224441...',
                '..133325422544551...',
                '..135254422555551...',
                '..132542222225551...',
                '.13332334453245551..',
                '.134425555555545511.',
                '13443442224444445551',
                '13443244444444544551',
                '.111444445445555111.',
                '....144411155511....',
                '.....111...111......',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('mindless_slime')],
    abilities: [onResolve((ctx) => {
            const targetId = plannedUnitId(ctx, 'target');
            if (targetId !== undefined)
                ctx.ops.transformCard(targetId, 'mindless_slime');
        })],
    ui: {
        mechanics: ['death'],
        planning: { steps: { target: { label: 'Выберите вражескую карту' } } },
    },
});
//# sourceMappingURL=liquefaction.js.map